import { render, staticRenderFns } from "./SubdistributorList.vue?vue&type=template&id=3cbbdf75&scoped=true"
import script from "./SubdistributorList.vue?vue&type=script&lang=js"
export * from "./SubdistributorList.vue?vue&type=script&lang=js"
import style0 from "./SubdistributorList.vue?vue&type=style&index=0&id=3cbbdf75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbbdf75",
  null
  
)

export default component.exports